export const chatHistory = {
    state: {
        sessionBotStatus: true
    },
    mutations: {
        'SET_SESSION_BOT_STATUS'(state,status) {
            state.sessionBotStatus = status
        }
    },
    actions: {
        setSessionBotStatus({commit},status){
            commit('SET_SESSION_BOT_STATUS',status)
        }
    }
}
